<template>
  <div>
    <BlFlexContainerMv direction="row" align-items="baseline" justify-content="flex-start" wrap="wrap">
      <button
        v-for="(item, index) in listItems"
        :key="index"
        class="w-[25%] h-[84px] flex p-0 bg-white border-none items-center qa-list-item"
        @click="toDetailPage(item)"
      >
        <BlFlexContainerMv direction="column" align-items="center">
          <img
            :src="item.image_url"
            :style="{width: `${iconSize}px`, height: `${iconSize}px`}"
            alt="image"
            class="inline-block object-contain qa-image-url"
          />
          <BlTextAv :ellipsis="2" variation="caption-12" class="qa-list-name text-center" style="margin-top: 6px">{{ item.name }}</BlTextAv>
        </BlFlexContainerMv>
      </button>
      <BlFlexItemAv v-if="hasMoreButton" class="w-[25%] h-[84px] flex justify-center items-center">
        <button class="flex flex-1 items-center justify-center flex-col p-0 bg-white border-none qa-click-more" @click="onClickMore">
          <div :style="{width: `${iconSize}px`, height: `${iconSize}px`}" class="flex items-center justify-center">
            <IconMore />
          </div>
          <BlTextAv variation="caption-12" style="margin-top: 6px">Lainnya</BlTextAv>
        </button>
      </BlFlexItemAv>
    </BlFlexContainerMv>
  </div>
</template>
<script>
import IconMore from 'public/images/kartu-prakerja/ic_more_dope.svg';
import {generateURLString} from 'shared_js/coupon-deals';

export default {
  name: 'PrakerjaListWithIcon',
  components: {IconMore},
  props: {
    moreButtonLink: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      required: true,
    },
    iconSize: {
      type: Number,
      default: 48,
    },
  },
  computed: {
    isOnLandingPage() {
      return this.$route.name === 'landing';
    },
    hasMoreButton() {
      if (!this.isOnLandingPage) {
        return false;
      } else {
        if (this.moreButtonLink === 'merchants') return true;
        return this.moreButtonLink === 'categories' && this.list.length > 7;
      }
    },
    listItems() {
      if (this.hasMoreButton) return this.list.slice(0, 7);
      return this.list;
    },
  },
  methods: {
    onClickMore() {
      this.$router.push({
        name: this.moreButtonLink,
        query: this.$route.query,
      });
    },
    toDetailPage(item) {
      if (this.moreButtonLink === 'merchants') {
        window.location.href = this.$router.resolve({
          name: 'merchant',
          params: {id: generateURLString(`${item.name} ${item.id}`)},
          query: {
            ...this.$route.query,
            source: 'tab-merchant',
          },
        }).href;
      } else {
        this.$router.push({
          name: 'category',
          params: {id: item.id},
          query: this.$route.query,
        });
      }
    },
  },
};
</script>
